import miniLogo from "../../../images/mini-logo.png";
import NoProfile from "../../../images/profileImage.png";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {DateGroupedIntervention} from "../../../utils/date";
import ImageComponent from "../shared/ImageComponent";
const ReviewCard = ({review}) => {
  return (
    <div className="w-full bg-white rounded-2xl shadow-md !p-4 border flex flex-col gap-2 relative">
      <img className="w-4 absolute top-2 right-2" src={miniLogo} alt="logo" />
      <div className="flex items-center justify-start gap-2">
        {/* Image de profil */}
        <div className="relative">
          <ImageComponent
            className="w-12 aspect-square rounded-full object-cover"
            width="70"
            src={buildImageUrl(review?.createdBy?.imageUri)}
            alt="profile"
            fallback={
              <img
                className="w-12 aspect-square rounded-full object-cover"
                width="70"
                src={NoProfile}
                alt="profile"
              />
            }
          />
          {!!review?.createdBy?.avgRating && (
            <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-white text-[8px] font-medium !px-1 !py-[1px] rounded-full">
              {Number(review?.createdBy?.avgRating).toFixed(2)}
            </span>
          )}
        </div>

        <div className="flex flex-col justify-center items-start gap-1">
          <div className="text-sm font-bold text-[#19295C] capitalize">
            {" "}
            {review?.createdBy?.lastname + " " + review?.createdBy?.firstname}
          </div>
          <div className="text-gray-500 text-xs">
            {DateGroupedIntervention(review?.createdAt)}
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div className="flex-1">
        {/* Étoiles */}
        <div className="flex items-center gap-1 ">
          {Array.from({length: 5}, (_, index) => (
            <div
              key={index}
              className={`font-bold text-lg ${
                index < Math.round(review?.rating)
                  ? "text-yellow-500"
                  : "text-gray"
              }`}
            >
              {" "}
              ★
            </div>
          ))}
        </div>

        {/* Titre */}
        {review?.Intervention?.Offer_Proposal?.Offer?.title && (
          <div className="flex text-sm items-center gap-2 text-[#19295C] font-bold">
            <i className="fi fi-rr-rectangle-list flex items-center "></i>
            <span>
              {review?.Intervention?.Offer_Proposal?.Offer?.title ?? "--"}
            </span>
          </div>
        )}

        {/* Description */}
        <p className="text-gray-500 text-xs mt-1">{review?.comment}</p>
      </div>
    </div>
  );
};

export default ReviewCard;
